import React, { Component } from 'react';
import Login from './pages/Login';
import Resume from './pages/Resume';

class Home extends Component {
  state = {
    valueTab: 0,
    valLogin: localStorage.getItem('login'),
    unit: localStorage.getItem('unit'),
  }

  render() {
    const { valLogin, unit } = this.state;
    if (valLogin && unit === 'poliklinik') {
      return <Resume/>
    } else {
      return <Login/>
    }
  }
}

export default Home;